// Dependencies imports
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";
import axios from "axios";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import qs from "qs";
import { DataGrid } from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";

// Local imports
import { ReactComponent as LeftArrow } from "../../assets/icons/leftarrow.svg";
import { ReactComponent as ActivateUser } from "../../assets/icons/activateuser.svg";
import { ReactComponent as DeactivateUser } from "../../assets/icons/deactivateuser.svg";
import { ReactComponent as EditUser } from "../../assets/icons/edituser.svg";
import { ReactComponent as DeleteUser } from "../../assets/icons/removeuser.svg";
import { authData } from "../../redux/auth/authSlice";
import { Constants } from "../../constants";
import SchoolDirectoryIcon from "../../assets/icons/directory.svg";
import ConfirmationModal from "./confirmationModal";

// Style imports
import Ad from "./addstudent.module.scss";
import EditSchoolModal from "./editSchoolModal";

const RootContainer = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  "& .super-app-theme--header": {
    fontSize: "16px",
    color: "rgb(255,255,255)",
    backgroundColor: "#f05e13",
  },
}));

const ModalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
}));

const BackdropContainer = styled("div")(({ theme }) => ({
  zIndex: theme?.zIndex?.drawer + 1,
  color: "#fff",
}));

const DataGridContainer = styled(Box)(({ theme }) => ({
  height: 500,
  width: "100%",
  "& .super-app-theme--header": {
    backgroundColor: "#f05e13",
    color: "white",
  },
}));

const SchoolDirectory = () => {
  const navigate = useNavigate();
  let userDetails = useSelector(authData);
  const [spin, setSpin] = useState(true);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [schoolDetails, setSchoolDetails] = useState();

  useEffect(() => {
    getDataGridData();
    //eslint-disable-next-line
  }, []);

  //   API to get graph and logs response
  const getDataGridData = () => {
    setSpin(true);
    var data = qs.stringify({});

    var config = {
      method: "GET",
      url: `${Constants.api_url}/schools/all_school_codes`,
      headers: {},
      data: data,
    };

    axios(config)
      .then(function (result) {
        console.log("school directory", result.data);
        tableViewConvertion(result.data);
      })
      .catch(function (error) {
        setSpin(false);
      });
  };

  const activateSchool = (param) => {
    setSpin(true);
    console.log("paramvalue inside activate school", param);
    var config = {
      method: "PUT",
      url: `${Constants.api_url}/schools/reactivate/${param.row.school_code}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    axios(config)
      .then(function (result) {
        getDataGridData();
      })
      .catch(function (error) {
        setSpin(false);
      });
  };

  const deactivateSchool = (param) => {
    setSpin(true);
    console.log("paramvalue inside deactivate", param);
    var config = {
      method: "PUT",
      url: `${Constants.api_url}/schools/deactivate/${param.row.school_code}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    axios(config)
      .then(function (result) {
        console.log("result data", result.data);
        getDataGridData();
      })
      .catch(function (error) {
        setSpin(false);
      });
  };

  const handleEditSchoolModalOpen = () => {
    setOpenEditModal(true);
  };

  const handleEditSchoolModalClose = () => {
    setOpenEditModal(false);
  };

  const handleConfirmationModalOpen = () => {
    setOpenDeleteModal(true);
  };

  const handleConfirmationModalClose = () => {
    setOpenDeleteModal(false);
  };

  const handleCellClick = (param, event) => {
    console.log("inside handlecell click");
    console.log("param value", param.value);
    if (param.value) {
      deactivateSchool(param);
    } else {
      activateSchool(param);
    }
  };

  const tableViewConvertion = (value) => {
    let trows = [];
    for (let i = 0; i < value.length; i++) {
      let obj = {};
      obj.id = i;
      obj.school_name = value[i].school_name;
      obj.school_code = value[i].school_code;
      obj.school_logo = value[i].school_logo;
      obj.admin_name = value[i].admin_name;
      obj.admin_email = value[i].admin_email;
      obj.admin_phone = value[i].admin_phone;
      obj.activate = value[i].is_active;
      obj.actions = value[i];
      trows.push(obj);
      console.log("is here two");
    }
    console.log("trows", trows);
    console.log("it is not here");

    const tcolumns = [
      {
        field: "school_logo",
        headerName: "School Logo",
        flex: 0.5,
        headerClassName: "super-app-theme--header",
        renderCell: (param) => {
          return (
            <img
              src={param.value}
              className={Ad.schoollogo}
              alt="school_logo"
            />
          );
        },
      },
      {
        field: "school_name",
        headerName: "School Name",
        flex: 1.2,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "school_code",
        headerName: "School Code",
        flex: 0.7,
        headerClassName: "super-app-theme--header",
      },

      {
        field: "admin_name",
        headerName: "Admin Name",
        flex: 0.5,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "admin_email",
        headerName: "Admin Email",
        flex: 1,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "admin_phone",
        headerName: "Admin Phone",
        flex: 0.8,
        headerClassName: "super-app-theme--header",
      },

      {
        field: "activate",
        headerName: "Access",
        flex: 0.4,
        headerClassName: "super-app-theme--header",
        renderCell: (param) => {
          return param.value ? (
            <DeactivateUser
              onClick={() => handleCellClick(param)}
              className={Ad.actionicons}
            />
          ) : (
            <ActivateUser
              onClick={() => handleCellClick(param)}
              className={Ad.actionicons}
            />
          );
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        flex: 0.8,
        headerClassName: "super-app-theme--header",
        renderCell: (param) => {
          console.log("what is inside actions", param);
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "1vw",
              }}
            >
              <EditUser
                className={Ad.actionicons}
                onClick={() => {
                  setSchoolDetails(param.value);
                  handleEditSchoolModalOpen();
                }}
              />
              <DeleteUser
                className={Ad.actionicons}
                onClick={() => {
                  setSchoolDetails(param.value);
                  handleConfirmationModalOpen();
                }}
              />
            </div>
          );
        },
      },
    ];

    setRows(trows);
    setColumns(tcolumns);
    setSpin(false);
  };

  return (
    // <RootContainer>
    <div className={Ad.maincontainer}>
      {spin && (
        <BackdropContainer>
          <CircularProgress style={{ color: "#226bf6" }} />
        </BackdropContainer>
      )}
      <ModalContainer>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openEditModal}
          onClose={handleEditSchoolModalClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          {/* <Fade in={openEditModal}> */}
          <EditSchoolModal
            handleEditStudentModalClose={handleEditSchoolModalClose}
            schoolDetails={schoolDetails}
            getDataGridData={getDataGridData}
          />
          {/* </Fade> */}
        </Modal>
      </ModalContainer>
      <ModalContainer>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openDeleteModal}
          onClose={handleConfirmationModalClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          {/* <Fade in={openDeleteModal}> */}
          <ConfirmationModal
            handleConfirmationModalClose={handleConfirmationModalClose}
            Details={schoolDetails}
            getDataGridData={getDataGridData}
            type={"school"}
          />
          {/* </Fade> */}
        </Modal>
      </ModalContainer>
      <div className={Ad.topbar}>
        <LeftArrow onClick={() => navigate(-1)} className={Ad.backbutton} />
      </div>
      <div className={Ad.headingholder}>
        <img
          className={Ad.addstudenticon}
          src={SchoolDirectoryIcon}
          alt="addstudenticon"
        />
        <h3 className={Ad.heading}>School Directory</h3>
      </div>
      {spin === false ? (
        <DataGridContainer
          sx={{
            height: 500,
            width: "100%",
            "& .super-app-theme--header": {
              backgroundColor: "#f05e13",
              color: "white",
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            rowHeight={50}
            disableSelectionOnClick
            sx={{
              boxShadow: 2,
              border: 2,
              borderColor: "#f05e13",
              "& .MuiDataGrid-cell:hover": {
                color: "primary.main",
              },
            }}
          />
        </DataGridContainer>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rect" width="100%" height={500} />
        </div>
      )}
    </div>
    //  </RootContainer>
  );
};

export default SchoolDirectory;
